import React, { useEffect } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import CartDrawer from '../components/cart/CartDrawer';
import { CONTACT_INFO, CARD_DESCRIPTOR } from '../data/mock';
import { FileText, Dumbbell } from 'lucide-react';

const TermsPage = () => {
  useEffect(() => {
    document.title = 'Terms & Conditions | Sport Fitt Pro';
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <CartDrawer />
      
      <main className="pt-[104px]">
        {/* Banner Section */}
        <section className="relative bg-white border-b border-ink-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-athletic-500/10 border border-athletic-500/30 rounded-full text-athletic-500 text-xs font-semibold mb-4">
              <FileText className="w-3.5 h-3.5" />
              LEGAL
            </div>
            <h1 className="font-display text-4xl md:text-5xl text-white font-extrabold mb-3">
              Terms & Conditions
            </h1>
            <p className="text-white/70 max-w-lg">
              Please read these terms carefully before using our services
            </p>
          </div>
        </section>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="bg-white border border-ink-100 rounded-2xl p-8 md:p-12">
            <div className="prose prose-invert max-w-none">
              <p className="text-ink-600 mb-8">
                Welcome to Sport Fitt Pro, operated by {CONTACT_INFO.corpName}. By accessing and using this website, you agree to be bound by these Terms and Conditions.
              </p>

              <h2 className="text-xl font-display font-bold text-ink-900 mt-8 mb-4">1. General Terms</h2>
              <p className="text-ink-600 mb-4">
                By using our website and services, you agree to these terms and conditions. We reserve the right to modify these terms at any time without prior notice. Your continued use of the website constitutes acceptance of any changes.
              </p>

              <h2 className="text-xl font-display font-bold text-ink-900 mt-8 mb-4">2. Products and Pricing</h2>
              <p className="text-ink-600 mb-4">
                All products are subject to availability. We reserve the right to discontinue any product at any time. Prices are subject to change without notice. All prices are displayed in US Dollars (USD).
              </p>

              <h2 className="text-xl font-display font-bold text-ink-900 mt-8 mb-4">3. Orders and Payment</h2>
              <p className="text-ink-600 mb-4">
                By placing an order, you represent that you are at least 18 years old and that the information you provide is accurate. We accept major credit cards and other payment methods as displayed at checkout. All charges will appear as "<span className="text-athletic-500 font-semibold">{CARD_DESCRIPTOR}</span>" on your credit card statement.
              </p>

              <h2 className="text-xl font-display font-bold text-ink-900 mt-8 mb-4">4. Shipping</h2>
              <p className="text-ink-600 mb-4">
                We ship within the United States. Shipping times and costs vary based on location and shipping method selected. We are not responsible for delays caused by carriers or customs.
              </p>

              <h2 className="text-xl font-display font-bold text-ink-900 mt-8 mb-4">5. Returns and Refunds</h2>
              <p className="text-ink-600 mb-4">
                We offer a 30-day return policy for unused items in original packaging. Please see our Returns page for detailed information on how to initiate a return. Refunds will be processed within 5-7 business days of receiving the returned item.
              </p>

              <h2 className="text-xl font-display font-bold text-ink-900 mt-8 mb-4">6. Intellectual Property</h2>
              <p className="text-ink-600 mb-4">
                All content on this website, including text, graphics, logos, and images, is the property of {CONTACT_INFO.corpName} and is protected by copyright laws. You may not reproduce, distribute, or use any content without our written permission.
              </p>

              <h2 className="text-xl font-display font-bold text-ink-900 mt-8 mb-4">7. Limitation of Liability</h2>
              <p className="text-ink-600 mb-4">
                We are not liable for any indirect, incidental, or consequential damages arising from your use of our products or services. Our liability is limited to the amount paid for the product in question.
              </p>

              <h2 className="text-xl font-display font-bold text-ink-900 mt-8 mb-4">8. Governing Law</h2>
              <p className="text-ink-600 mb-4">
                These terms are governed by the laws of the State of Arizona, United States. Any disputes shall be resolved in the courts of Arizona.
              </p>

              <h2 className="text-xl font-display font-bold text-ink-900 mt-8 mb-4">9. Contact Information</h2>
              <p className="text-ink-600 mb-4">
                For questions about these terms, please contact us:
              </p>
              <div className="bg-ink-50 border border-ink-200 rounded-xl p-6">
                <p className="text-ink-900 font-semibold">{CONTACT_INFO.corpName}</p>
                <p className="text-ink-600">{CONTACT_INFO.address.street}</p>
                <p className="text-ink-600">{CONTACT_INFO.address.city}, {CONTACT_INFO.address.state} {CONTACT_INFO.address.zip}</p>
                <p className="text-ink-600 mt-2">Email: <a href={`mailto:${CONTACT_INFO.email}`} className="text-athletic-500 hover:underline">{CONTACT_INFO.email}</a></p>
                <p className="text-ink-600">Phone: <a href={`tel:${CONTACT_INFO.phone.replace(/[^0-9]/g, '')}`} className="text-athletic-500 hover:underline">{CONTACT_INFO.phone}</a></p>
              </div>

              <p className="text-ink-400 text-sm mt-8">
                Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
              </p>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default TermsPage;
